import { z } from 'zod';

export const userProfileSchema = z.looseObject({
	id: z.string(),
	emailAddress: z.string(),
	fullName: z.string().nullable(),
	companyName: z.string().nullable(),
	updatedAt: z.string().nullable(),
	termsAcceptedAt: z.string().nullable(),
});
